import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMyPricePlan } from 'services/pricePlan';

export const ThunkGetMyPricePlan = createAsyncThunk('pricePlan/getMyPricePlan', () =>
  getMyPricePlan().then(res => res.data),
);
